// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3024":"786e0345","4892":"786e0345","8995":"69f39437"}[chunkId] + ".chunk.css";
};